<template>
    <custom-cropper></custom-cropper>
</template>

<script>
import CustomCropper from './components/CustomCropper.vue'

export default {
  name: 'app',
  components: {
    CustomCropper
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?5f17874e